import React from 'react'
import BodyComponent from '../components/Body/BodyComponent'

function RentPage() {
  return (
    <BodyComponent />
  )
}

export default RentPage